// Module
var code = "<section class=\"new-core-poc\"> new-core-poc works! <button class=\"btn\">Basic</button> <button class=\"btn btn-primary\">Primary</button> <button class=\"btn btn-danger\">Danger</button> </section> ";
// Exports
export default code;